const account_center = {
    not_enabled: '帳戶中心尚未啟用。',
    filed_not_editable: '欄位不可編輯。',
};
export default Object.freeze(account_center);
